import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { supabase } from '../lib/supabase';

export default function AuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    async function finishLogin() {
      const next = searchParams.get('next') || '/';

      // Supabase client auto-parses the session from the URL on load.
      // Poll briefly until it's actually available before navigating.
      const { data: { session } } = await supabase.auth.getSession();

      if (session) {
        navigate(next, { replace: true });
        return;
      }

      // Fallback: listen for the auth event in case getSession() was too early
      const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
        if (session) {
          subscription.unsubscribe();
          navigate(next, { replace: true });
        }
      });

      // Safety timeout — if nothing happens in 5s, send to login with error
      const timeout = setTimeout(() => {
        subscription.unsubscribe();
        navigate('/login?error=auth_failed', { replace: true });
      }, 5000);

      return () => {
        clearTimeout(timeout);
        subscription.unsubscribe();
      };
    }
    finishLogin();
  }, [navigate, searchParams]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--brand-paper)' }}>
      <div style={{ width: 40, height: 40, border: '3px solid var(--brand-sand)', borderTopColor: 'var(--feedback-warning)', borderRadius: 'var(--radius-circle)', animation: 'spin 0.8s linear infinite' }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}